import React from "react";
import styles from "./CreateButton.module.css";
import Box from "@mui/material/Box";

function CreateButton({ handleCreateCase, handleClose }) {
  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <button
          type="button"
          className={styles.customButton}
          onClick={(event) => {
            handleCreateCase(event);
            handleClose(event);
          }}
        >
          Create Case
        </button>
      </Box>
    </>
  );
}

export default CreateButton;
